module.exports = __webpack_public_path__ + "static/Avenir-Heavy-e446eb3933de7de1d4245e8febe0137d.ttf";